import { useQuery } from '@apollo/client';

import GetOnboardingModuleConfig from 'bundles/onboarding-common/queries/GetOnboardingModuleConfig.graphql';
import type {
  GetOnboardingModuleConfigQuery,
  GetOnboardingModuleConfigQueryVariables,
} from 'bundles/onboarding-common/queries/__generated__/GetOnboardingModuleConfig';
import type { InferredRole, ModularOnboardingEntrypoint } from 'bundles/onboarding-common/types';

export type OnboardingModuleConfigRequest = {
  entrypoint: ModularOnboardingEntrypoint;
  inferredRole?: InferredRole;
};

const useGetOnboardingModuleConfig = (configInput: OnboardingModuleConfigRequest, skip: boolean = false) => {
  const { data, loading } = useQuery<GetOnboardingModuleConfigQuery, GetOnboardingModuleConfigQueryVariables>(
    GetOnboardingModuleConfig,
    {
      variables: { entrypoint: configInput.entrypoint, inferredRoleId: configInput.inferredRole?.id },
      skip,
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
      context: {
        clientName: 'gatewayGql',
      },
    }
  );

  return {
    displayModule: data?.LearnerOnboarding?.getOnboardingModuleConfig?.displayModule,
    module: data?.LearnerOnboarding?.getOnboardingModuleConfig?.module,
    loading,
  };
};

export default useGetOnboardingModuleConfig;
